import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MealCalculator from './components/MealCalculator';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentCancelled from './components/PaymentCancelled';
import { pokeDatabase } from './services/keepAliveService';
import './App.css';

function App() {
  // Initialize Database Keep-Alive/Warmup
  useEffect(() => {
    // Fire the "poke" immediately on app load
    // This ensures that even bot traffic (SEO crawlers) keeps the DB active
    pokeDatabase();
  }, []);

  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<MealCalculator />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancelled" element={<PaymentCancelled />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;